export default __webpack_public_path__ + "static/media/langer_bus_front.62dd722d.jpg";